import * as React from 'react';
import { useState } from 'react';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Footer from '../informational/Footer';
import featuresConfig from './features.json';

function MobileHomeContent({ onLogin }) {
    const [features] = useState(featuresConfig.features);
    const [isLoading] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [currentFeatureSlide, setCurrentFeatureSlide] = useState(0);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const [featureTouchStart, setFeatureTouchStart] = useState(null);
    const [featureTouchEnd, setFeatureTouchEnd] = useState(null);


    // Carousel functions
    const handleTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;

        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > 50;
        const isRightSwipe = distance < -50;

        if (isLeftSwipe && currentSlide < carouselSlides.length - 1) {
            setCurrentSlide(currentSlide + 1);
        }
        if (isRightSwipe && currentSlide > 0) {
            setCurrentSlide(currentSlide - 1);
        }
    };

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    // Feature carousel functions
    const handleFeatureTouchStart = (e) => {
        setFeatureTouchEnd(null);
        setFeatureTouchStart(e.targetTouches[0].clientX);
    };

    const handleFeatureTouchMove = (e) => {
        setFeatureTouchEnd(e.targetTouches[0].clientX);
    };

    const handleFeatureTouchEnd = () => {
        if (!featureTouchStart || !featureTouchEnd) return;

        const distance = featureTouchStart - featureTouchEnd;
        const isLeftSwipe = distance > 50;
        const isRightSwipe = distance < -50;

        if (isLeftSwipe && currentFeatureSlide < features.length - 1) {
            setCurrentFeatureSlide(currentFeatureSlide + 1);
        }
        if (isRightSwipe && currentFeatureSlide > 0) {
            setCurrentFeatureSlide(currentFeatureSlide - 1);
        }
    };

    const goToFeatureSlide = (index) => {
        setCurrentFeatureSlide(index);
    };

    // Carousel data
    const carouselSlides = [
        {
            title: 'Connect',
            image: '/connect.png',
            alt: 'Connect'
        },
        {
            title: 'Select',
            image: '/select.png',
            alt: 'Select'
        },
        {
            title: 'Save',
            image: '/save.png',
            alt: 'Save'
        }
    ];

    // Calculate slide percentage dynamically
    const slidePercentage = 100 / carouselSlides.length;


    return (
        <Box sx={{
            minHeight: '50vh',
            width: '100%',
            background: [
                'linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url("/landing/hero_mobile_16_9.jpg")'
            ],
            backgroundSize: { xs: '100% auto' },
            position: 'relative',
            margin: 0,
            padding: 0,
            zIndex: 1,
            imageRendering: 'crisp-edges',
            WebkitImageRendering: 'crisp-edges',
            msImageRendering: 'crisp-edges'
        }}>
            {/* Hero Section - Value Statement */}
            <Box sx={{
                position: 'relative',
                width: '100%',
                height: '70vh',
                // minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2,
                px: 2,
                margin: 0,
                padding: 0,
            }}>
                <Box
                    component="img"
                    src="/landing/chart.svg"
                    alt="Chart Overlay"
                    sx={{
                        position: 'absolute',
                        top: '35%',
                        left: '50%',
                        transform: 'translate(-50%, -35%)',
                        width: '90%',
                        height: 'auto',
                        opacity: 0.7,
                        zIndex: 1
                    }}
                />
                <Box sx={{
                    position: 'relative',
                    zIndex: 2,
                    textAlign: 'center',
                    // backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    padding: { xs: '2rem 1.5rem', sm: '2.5rem 2rem' },
                    borderRadius: 3,
                    maxWidth: '90%',
                    // backdropFilter: 'blur(1px)',
                    // border: '1px solid rgba(255, 255, 255, 0.1)'
                }}>
                    <Typography variant="h4" component="h1" sx={{
                        fontSize: { xs: '1.6rem', sm: '2rem', md: '2.4rem' },
                        fontWeight: 700,
                        color: 'white',
                        textShadow: '0 2px 8px rgba(0,0,0,0.7)',
                        lineHeight: 1.3,
                        mb: 1
                    }}>
                        Seamlessly create, customize,
                        <br />
                        and download elevation
                        <br />
                        cue cards for your adventures
                    </Typography>
                </Box>

                {/* Partnership statement */}
                <Box sx={{
                    position: 'absolute',
                    bottom: 20,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 2,
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    padding: '10px 20px',
                    borderRadius: 3,
                    backdropFilter: 'blur(15px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
                }}>
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="body2" sx={{ opacity: 0.7, mb: 1, color: 'white' }}>
                            In Partnership With
                        </Typography>
                        <Box
                            component="a"
                            href="https://acier.cc"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                color: 'white',
                                textDecoration: 'none',
                                '&:hover': { opacity: 0.8 },
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                            }}
                        >
                            <Box
                                component="img"
                                src="/acier_logo_full.jpg"
                                alt="Acier"
                                sx={{
                                    height: 40,
                                    width: 'auto'
                                }}
                            />
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                Acier.cc
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>

            {/* Sections with Gradient Background */}
            <Box sx={{
                background: 'linear-gradient(to bottom, rgba(45, 74, 105, 0.1)  0%, rgba(45, 74, 105, 0.9) 10%, rgba(45, 74, 105, 0.9) 40%, #2d4a69 100%)',
                position: 'relative',
                zIndex: 2,
                minHeight: '100vh'
            }}>
                {/* Action Buttons Section */}
                <Box sx={{
                    position: 'relative',
                    zIndex: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 3,
                    py: { xs: 5, sm: 6 },
                    px: 3
                }}>
                    <Button
                        variant="contained"
                        size="large"
                        onClick={() => {
                            document.getElementById('get-connected-section')?.scrollIntoView({
                                behavior: 'smooth'
                            });
                        }}
                        sx={{
                            backgroundColor: '#FF5722',
                            color: 'white',
                            fontWeight: 600,
                            px: 4,
                            py: 2,
                            borderRadius: 3,
                            fontSize: { xs: '1.1rem', sm: '1.2rem' },
                            width: '100%',
                            maxWidth: 320,
                            minHeight: 56,
                            boxShadow: '0 4px 15px rgba(255, 107, 53, 0.3)',
                            '&:hover': {
                                backgroundColor: '#FF5722',
                                transform: 'translateY(-2px)',
                                boxShadow: '0 6px 20px rgba(255, 107, 53, 0.4)'
                            },
                            '&:active': {
                                transform: 'translateY(0px)'
                            },
                            transition: 'all 0.3s ease'
                        }}
                    >
                        Get Connected
                    </Button>
                    <Button
                        variant="contained"
                        size="large"
                        onClick={() => {
                            document.getElementById('see-it-in-action-section')?.scrollIntoView({
                                behavior: 'smooth'
                            });
                        }}
                        sx={{
                            backgroundColor: '#1976d2',
                            color: 'white',
                            fontWeight: 600,
                            px: 4,
                            py: 2,
                            borderRadius: 3,
                            fontSize: { xs: '1.1rem', sm: '1.2rem' },
                            width: '100%',
                            maxWidth: 320,
                            minHeight: 56,
                            boxShadow: '0 4px 15px rgba(25, 118, 210, 0.3)',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                transform: 'translateY(-2px)',
                                boxShadow: '0 6px 20px rgba(25, 118, 210, 0.4)'
                            },
                            '&:active': {
                                transform: 'translateY(0px)'
                            },
                            transition: 'all 0.3s ease'
                        }}
                    >
                        See It in Action
                    </Button>
                </Box>

                {/* Process Flow Section */}
                <Box
                    id="get-connected-section"
                    sx={{
                        py: { xs: 5, sm: 6 },
                        px: 3,
                        position: 'relative',
                        zIndex: 2
                    }}
                >
                    <Container maxWidth="sm">
                        <Typography variant="h4" component="h2" sx={{
                            textAlign: 'center',
                            mb: { xs: 5, sm: 6 },
                            color: 'white',
                            fontWeight: 700,
                            fontSize: { xs: '1.8rem', sm: '2.2rem' }
                        }}>
                            Get Connected
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
                            {/* Carousel Container */}
                            <Box sx={{
                                width: '100%',
                                maxWidth: 320,
                                position: 'relative',
                                overflow: 'hidden',
                                borderRadius: 3,
                                boxShadow: '0 6px 20px rgba(0,0,0,0.15)'
                            }}>
                                {/* Carousel Slides */}
                                <Box
                                    onTouchStart={handleTouchStart}
                                    onTouchMove={handleTouchMove}
                                    onTouchEnd={handleTouchEnd}
                                    sx={{
                                        display: 'flex',
                                        transition: 'transform 0.3s ease-in-out',
                                        transform: `translateX(-${currentSlide * slidePercentage}%)`,
                                        width: `${carouselSlides.length * 100}%`
                                    }}
                                >
                                    {carouselSlides.map((slide, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                width: `${slidePercentage}%`,
                                                flexShrink: 0,
                                                backgroundColor: 'white',
                                                borderRadius: 3,
                                                border: '1px solid #e9ecef',
                                                overflow: 'hidden',
                                                transition: 'all 0.3s ease',
                                                '&:hover': {
                                                    transform: 'translateY(-4px)',
                                                    boxShadow: '0 8px 25px rgba(0,0,0,0.2)'
                                                }
                                            }}
                                        >
                                            <Box sx={{
                                                padding: { xs: '1.2rem', sm: '1.5rem' },
                                                textAlign: 'center',
                                                backgroundColor: '#f8f9fa'
                                            }}>
                                                <Typography variant="h6" sx={{
                                                    color: '#2c3e50',
                                                    fontWeight: 600,
                                                    fontSize: { xs: '1.1rem', sm: '1.2rem' }
                                                }}>
                                                    {slide.title}
                                                </Typography>
                                            </Box>
                                            <Box
                                                component="img"
                                                src={slide.image}
                                                alt={slide.alt}
                                                sx={{
                                                    width: '100%',
                                                    height: 'auto',
                                                    display: 'block'
                                                }}
                                            />
                                        </Box>
                                    ))}
                                </Box>
                            </Box>

                            {/* Carousel Indicators */}
                            <Box sx={{
                                display: 'flex',
                                gap: 1,
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                                {carouselSlides.map((_, index) => (
                                    <Box
                                        key={index}
                                        onClick={() => goToSlide(index)}
                                        sx={{
                                            width: 12,
                                            height: 12,
                                            borderRadius: '50%',
                                            backgroundColor: currentSlide === index ? '#FF5722' : '#e9ecef',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease',
                                            '&:hover': {
                                                backgroundColor: currentSlide === index ? '#FF5722' : '#dee2e6'
                                            }
                                        }}
                                    />
                                ))}
                            </Box>
                        </Box>
                    </Container>
                </Box>

                {/* Features Section */}
                <Box
                    id="see-it-in-action-section"
                    sx={{
                        py: { xs: 5, sm: 6 },
                        px: 3,
                        position: 'relative',
                        zIndex: 2
                    }}
                >
                    <Container maxWidth="sm">
                        <Typography variant="h4" component="h2" sx={{
                            textAlign: 'center',
                            mb: { xs: 5, sm: 6 },
                            color: 'white',
                            fontWeight: 700,
                            fontSize: { xs: '1.8rem', sm: '2.2rem' }
                        }}>
                            See It in Action
                        </Typography>
                        {isLoading ? (
                            <Box sx={{ textAlign: 'center', py: 4 }}>
                                <Typography variant="h6" sx={{ color: 'white' }}>
                                    Loading features...
                                </Typography>
                            </Box>
                        ) : (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                {/* Feature Carousel */}
                                <Box sx={{
                                    width: '100%',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    borderRadius: 3,
                                    boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
                                    border: '2px solid #e9ecef',
                                    backgroundColor: 'white'
                                }}>
                                    {/* Carousel Slides */}
                                    <Box
                                        onTouchStart={handleFeatureTouchStart}
                                        onTouchMove={handleFeatureTouchMove}
                                        onTouchEnd={handleFeatureTouchEnd}
                                        sx={{
                                            display: 'flex',
                                            transition: 'transform 0.3s ease-in-out',
                                            transform: `translateX(-${currentFeatureSlide * (100 / features.length)}%)`,
                                            width: `${features.length * 100}%`
                                        }}
                                    >
                                        {features.map((feature, index) => (
                                            <Box
                                                key={feature.id}
                                                sx={{
                                                    width: `${100 / features.length}%`,
                                                    flexShrink: 0,
                                                    minHeight: { xs: 220, sm: 250 },
                                                    position: 'relative',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                {feature.mediaType === 'gif' ? (
                                                    <Box
                                                        component="img"
                                                        src={`/features/${feature.media}`}
                                                        alt={feature.title}
                                                        sx={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover'
                                                        }}
                                                    />
                                                ) : (
                                                    <Box
                                                        component="img"
                                                        src={`/features/${feature.media}`}
                                                        alt={feature.title}
                                                        sx={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover'
                                                        }}
                                                    />
                                                )}
                                                {/* Overlay Title with customizable positioning */}
                                                <Box sx={{
                                                    position: 'absolute',
                                                    top: feature.titlePosition?.top || '20px',
                                                    left: feature.titlePosition?.left || '20px',
                                                    right: feature.titlePosition?.right || 'auto',
                                                    bottom: feature.titlePosition?.bottom || 'auto',
                                                    transform: feature.titlePosition?.transform || 'none',
                                                    background: feature.titlePosition?.background || 'rgba(0, 0, 0, 0.7)',
                                                    backdropFilter: feature.titlePosition?.backdropFilter || 'blur(10px)',
                                                    borderRadius: feature.titlePosition?.borderRadius || '8px',
                                                    padding: feature.titlePosition?.padding || '12px 16px',
                                                    maxWidth: feature.titlePosition?.maxWidth || '80%',
                                                    textAlign: feature.titlePosition?.textAlign || 'left'
                                                }}>
                                                    <Typography
                                                        variant={feature.titlePosition?.variant || 'h6'}
                                                        sx={{
                                                            color: feature.titlePosition?.color || 'white',
                                                            fontWeight: feature.titlePosition?.fontWeight || 600,
                                                            fontSize: feature.titlePosition?.fontSize || { xs: '1rem', sm: '1.1rem' },
                                                            lineHeight: feature.titlePosition?.lineHeight || 1.2,
                                                            textShadow: feature.titlePosition?.textShadow || '0 2px 4px rgba(0,0,0,0.5)',
                                                            margin: 0
                                                        }}
                                                    >
                                                        {feature.title}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>

                                {/* Feature Carousel Indicators */}
                                <Box sx={{
                                    display: 'flex',
                                    gap: 1,
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    {features.map((_, index) => (
                                        <Box
                                            key={index}
                                            onClick={() => goToFeatureSlide(index)}
                                            sx={{
                                                width: 12,
                                                height: 12,
                                                borderRadius: '50%',
                                                backgroundColor: currentFeatureSlide === index ? '#FF5722' : '#e9ecef',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease',
                                                '&:hover': {
                                                    backgroundColor: currentFeatureSlide === index ? '#FF5722' : '#dee2e6'
                                                }
                                            }}
                                        />
                                    ))}
                                </Box>
                            </Box>
                        )}
                    </Container>
                </Box>
            </Box>

            <Footer />
        </Box>
    );
}

export default MobileHomeContent;
